import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { safeSessionStorage } from '@local/utils';

type SelectedAddress = {
  id?: string | null;
  street_address1: string;
  street_address2?: string | null;
  city: string;
  state: string;
  zip: string;
  country: string;
  country_alpha2?: string;
  formatted_address?: string;
  latitude?: string;
  longitude?: string;
  delivery_instructions?: string | null;
  types?: string[];
};

type SelectedAddressStore = {
  address?: SelectedAddress;
  setAddress: (address?: SelectedAddress) => void;
  clearAddress: () => void;
};

const initialState = {
  address: undefined,
};

export const useSelectedAddressStore = create<SelectedAddressStore>()(
  persist(
    (set) => ({
      ...initialState,
      setAddress: (value?: SelectedAddress) => {
        set({ address: value });
      },
      clearAddress: () => {
        set({ address: undefined });
      },
    }),
    {
      name: 'chownow:diner:selected-address',
      storage: createJSONStorage(() => safeSessionStorage),
    }
  )
);
